import { useSelector } from '@bonanza-social/toolkit/state';
import { selectAccountStatus, selectAccountStatusReason } from '@bonanza-social/account';
import { BottomSheet } from '@bonanza-social/navigation';
import { useMemo } from 'react';

const usePurchaseEligibilityCheck = () => {
  const accountStatus = useSelector(selectAccountStatus);
  const accountStatusReason = useSelector(selectAccountStatusReason);

  const openErrorBottomSheet = useMemo(() => {
    if (accountStatusReason === 'KYC Verification Pending') {
      return () =>
        BottomSheet.open({
          namespace: 'shop',
          type: 'VerificationPending',
        });
    } else if (accountStatus === 'Timeout') {
      return () =>
        BottomSheet.open({
        namespace: 'common',
        type: 'InfoImage',
        data: {
          image: 'common.rejected',
          titleNS: 'common',
          titleKey: 'errorTitle',
          descriptionNS: 'shop',
          descriptionKey: 'errorUserOnBreak',
        },
      });
      return;
    } else if (accountStatus === 'Suspended') {
      return () =>
        BottomSheet.open({
          namespace: 'common',
          type: 'Info',
          titleNS: 'shop',
          titleKey: 'shopErrorTitleHmm',
          data: {
            textNS: 'shop',
            textKey: 'errorUserSuspended',
          },
        });
    } else if (accountStatus !== 'Approved') {
      return () =>
        BottomSheet.open({
          namespace: 'common',
          type: 'Info',
          titleNS: 'shop',
          titleKey: 'shopErrorTitleHmm',
          data: {
            textNS: 'shop',
            textKey: 'errorUserPending',
          },
        });
    }
  }, [accountStatus, accountStatusReason]);

  return openErrorBottomSheet;
};

export default usePurchaseEligibilityCheck;
